<template>
  <div>
    <!-- <Swiper :data="swiperList" /> -->
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
        <img :src="item.carouselImg" class="banner-image" v-if="index == 0" />
        <img v-lazy="item.carouselImg" class="banner-image" v-else />
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="category-view">
          <h3 class="model-title">类目概览</h3>
          <div class="model-name-en">Category overview</div>
          <div class="category-list">
            <div class="category-item" v-for="(item, index) in categoryList" :key="index" @click="goCategory(item)">
              <img v-lazy="item.image" class="imagecover" />
              <div class="category-item-name">{{item.name}}</div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide gray-bg">
        <div class="project-dynamic">
          <h3 class="model-title">项目动态</h3>
          <div class="model-name-en">Project News</div>
          <div class="project-dynamic-content">
            <el-row :gutter="20">
              <el-col :span="10" :offset="2" v-for="(item, index) in dynamicList" :key="index">
                <div class="dynamic-item">
                  <div class="dynamic-item-name more-t-2" @click="toArticle(item)" :title="item.title">{{item.title}}</div>
                  <div class="dynamic-item-image">
                    <img v-lazy="item.img || placeholderImg" class="imagecover" />
                  </div>
                  <div class="dynamic-item-desc more-t-2">{{item.brief}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="link-btn">
            <router-link to="/dynamic">
              <img src="@/assets/images/link-btn.png" />
            </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="vr-model">
          <h3 class="model-title">VR总览</h3>
          <div class="vr-model-content" id="vrPre">
            <iframe :src="vrSrc" width="100%" height="100%" frameborder="0" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide gray-bg">
        <div class="project-industry">
          <h3 class="model-title">项目产业</h3>
          <div class="model-name-en">Project industry</div>
          <div class="project-industry-content">
            <Accordion :data="accordionList" />
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import _ from 'lodash'
import { getCarousel, loadYxTitle } from '@/api/api'
import {
  parseTime
} from '@/utils/index'
import { placeholderImg } from '@/config'
import Swiper from './components/Swiper'
import Accordion from '@/components/Accordion'
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Swiper,
    Accordion,
    swiper,
    swiperSlide
  },
  data() {
    return {
      placeholderImg,
      // vrSrc: 'https://vr.gdyfpt.com/static/tour.html?id=59',
      vrSrc: '',
      categoryList: [
        {
          name: '景区VR',
          image: require('@/assets/images/vr.jpg'),
          url: 'https://vr.gdyfpt.com/static/tour.html?id=59'
        },
        // {
        //   name: '实时摄像头',
        //   image: require('@/assets/images/overview.png')
        // },
        {
          name: '新闻动态',
          image: require('@/assets/images/news.png'),
          route: '/dynamic'
        }
      ],
      dynamicList: [],
      accordionList: [],
      // 幻灯片
      swiperList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 70, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;
            // console.log(swiper, swiper.activeIndex); //滑动打印当前索引
            if(swiper.activeIndex >= this.swiperList.length + 2 && !this.vrSrc) {
              this.vrSrc = 'https://vr.gdyfpt.com/static/tour.html?id=59'
            }
            // if (swiper.activeIndex === this.list.length - 1) {
            //   //到最后一个加载更多数据
            //   let newList = [];
            //   let listLength = this.list.length;
            //   for (let i = 0; i < 10; i++) {
            //     newList.push(listLength + i);
            //   }
            //   this.list = this.list.concat(newList);
            // }
          }
        }
      }
    }
  },
  mounted() {

    this.loadCarousel()
    this.loadArticles()
  },
  beforeDestroy() {
  },
  methods: {
    parseTime,
    loadCarousel() {
      getCarousel({
        page: 0,
        size: 20
      }).then(res => {
        var data = res.content.filter(item => {
          return item.isShow == 0
        })
        data = _.sortBy(data, (o) => {
          return o.carouselSort
        })
        // carouselSort
        this.swiperList = data
      })
    },
    loadArticles() {
      loadYxTitle().then(res => {
        var data = res.content.find(item => {
          return item.titleType == 1
        })
        var data2 = res.content.find(item => {
          return item.titleType == 6
        })
        if(data) {
          var list = data.articleTypeList.find(item => {
            return item.articleDetailList
          })
          this.dynamicList = list ? list.articleDetailList.splice(0, 2) : []
        }
        if(data2 && data2.articleTypeList.length > 0) {
          var detailList = data2.articleTypeList[0].articleDetailList
          if(detailList) {
            this.accordionList = detailList
          }
        }
      })
    },
    toArticle(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    },
    goCategory(item) {
      if(item.route) {
        this.$router.push({
          path: item.route
        })
      } else if(item.url) {
        window.open(item.url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .model-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 400;
    padding: 10px 0;
    font-size: 30px;
    color: #333333;
  }
  .model-name-en {
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-weight: 400;
    padding: 10px 0;
    font-size: 20px;
    color: #333333;
  }
  .category-view {
    padding-top: 40px;
  }
  .category-list {
    text-align: center;
    font-size: 0;
    overflow: hidden;
    padding: 80px 0 0;
    .category-item {
      width: 380px;
      height: 240px;
      display: inline-block;
      margin-right: 30px;
      position: relative;
      cursor: pointer;
      vertical-align: middle;
      &:last-child {
        margin: 0;
      }
      .category-item-name {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 42px;
        line-height: 42px;
        background: rgba(57, 57, 57, .6);
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
  .project-dynamic {
    padding: 40px 0 0;
    .project-dynamic-content {
      padding: 40px 0;
      width: 1200px;
      margin: 0 auto;
    }
    .dynamic-item {
      .dynamic-item-time {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 16px;
        color: #999999;
        margin-bottom: 14px;
      }
      .dynamic-item-name {
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .dynamic-item-image {
        width: 100%;
        height: 260px;
        margin-bottom: 18px;
      }
      .dynamic-item-desc {
        padding-top: 20px;
        border-top: 1px solid #ECECEC;
        line-height: 20px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #999999;
      }
    }
  }
  .project-activity {
    padding: 40px 0 80px;
  }
  .vr-model {
    padding: 20px 0 0;
    .vr-model-content {
      width: 1200px;
      height: calc(100vh - 70px - 100px);
      margin: 20px auto 0;
    }
  }
  .project-industry {
    padding: 20px 0 0;
    .project-industry-content {
      width: 1200px;
      height: 572px;
      margin: 0 auto;
      padding-top: 20px;
    }
  }
  .link-btn {
    width: 150px;
    height: 30px;
    cursor: pointer;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .gray-bg {
    background: #F8F8F8;
  }
  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>